import MaterialTable, { MTableToolbar } from "material-table";
import { useSelector } from "react-redux";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { GetEmployeesAction } from "../../../../store/Employee/Employee/Action";
import { useEffect } from "react";
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  CircularProgress,
  Avatar,
  Badge,
  Modal,
  Slider,
  Button,
  Typography,
} from "@mui/material";
import { checkPayrollAccess, ConvertDateTime, getDomain, getUserData, getUserId, loadFaceApiModels, s3Client} from "../../Base/helper/baseFunctions";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { v4 as uuidv4 } from "uuid";
import { convertBase64 } from "../../Base/helper/baseFunctions";
import Webcam from "react-webcam";
import { PhotoCamera, Person, Close, CameraAlt } from '@mui/icons-material';
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import * as faceapi from "face-api.js";
import DeleteIcon from '@mui/icons-material/Delete';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import ArchiveIcon from "@mui/icons-material/Archive";
import { GetATSModuleFeaturesAction } from "../../../../store/RoleAccess/ATSModuleFeatures/Action";
import history from "../../../../history";
import ConfirmationDialog from "../../Base/views/ConfirmationDialog";
import CustomToggle from "../../Base/views/CustomToggle";
import {GetUserWorkLocationHelper, UpdateEmployeeProfilePicHelper, UpdateEmployeeStatusHelper } from "../../Employee/helper/EmployeeHelper";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LogoutIcon from '@mui/icons-material/Logout';
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
import Popup from "../../Base/views/Popup";
import AddEmployeePopup from "./AddEmployeePopup";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import EmployeePayroleTemplate from "../../Finance/views/Employee/EmployeePayroleTemplate";
import AddIcon from '@mui/icons-material/Add';
import { getExportEmployeeDataHelper } from "../../Finance/helper/ProfileHelper";
import { toast } from "react-toastify";
import { GetHomeAction } from "../../../../store/EmployeeDashboard/Action";
import MyEcms from "../../ECMSystem/views/MyEcms/MyEcms";
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { checkLighting } from "../../Base/views/FaceLightingChecker";
import SelectableMultiSelect from "../../Base/views/SelectableMultiSelect";
import BackdropMeepl from "../../Ancillary/AnimationComponents/BackdropMeepl";
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import EmployeeLocationMap from "../helpers/EmployeeLocationMap";
import { socket } from "../../../../utils/socket";
import { generateEmbeddingsControllerHelper } from "../../FaceAttendance/helper/FaceRecognizationHelper";

const LazyEmployeeAvatar = ({ employee, onImageClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const avatarRef = useRef();

  useEffect(() => {
    // Store the current ref value in a variable
    const currentRef = avatarRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []); // Empty dependency array means this runs once on mount

  useEffect(() => {
    if (isVisible && employee.image) {
      const loadImage = async () => {
        try {
          const bucketParams = {
            Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
            Key: employee.image,
          };
          const url = await getSignedUrl(
            s3Client,
            new GetObjectCommand(bucketParams),
            { expiresIn: 15 * 60 }
          );
          setImageUrl(url);
        } catch (error) {
          console.warn(`Failed to load image for employee ${employee.employee_id}`);
        }
      };
      loadImage();
    }
  }, [isVisible, employee.image, employee.employee_id]);

  return (
    <Avatar
      ref={avatarRef}
      src={imageUrl}
      alt={employee.name}
      onClick={(e) => {
        e.stopPropagation();
        onImageClick(e, employee);
      }}
      sx={{ 
        width: 35, 
        height: 35, 
        cursor: 'pointer',
        border: '2px solid #f0f0f0'
      }}
    >
      {!imageUrl && <Person sx={{ fontSize: 20 }} />}
    </Avatar>
  );
};
const MyEmployeeGrid = ({ setCurrentMode, setData }) => {
  const userData = getUserData();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [inactive, setInactive] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [openTemplate, setOpenTemplate] = useState(false);
  const [openExitForm, setOpenExitForm] = useState(false);
  const [exitEmployeeData, setExitEmployeeData] = useState({})
  const [isExporting, setIsExporting] = useState(false);
  const open = Boolean(anchorEl);
  const [openImageUpload, setOpenImageUpload] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [openCropModal, setOpenCropModal] = useState(false);
  const cropperRef = useRef(null);
  const [useWebcam, setUseWebcam] = useState(false);
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [webImage, setWebImage] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [imageLoading, setImageLoading] = useState(false);
  const [lightingError, setLightingError] = useState("");
  const [imageValidation, setImageValidation] = useState(false);
  const [facingMode, setFacingMode] = useState("user");
  const isMobileOrTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const ExternalUserCoreHr = atsModuleData?.some((item) => item.module_name === "External User CoreHr");
  const [filters, setFilters] = useState({
            ats_work_location_id: []
    });
  const { employees_options, isEmployeeLoading } = useSelector(
    (state) => state?.EmployeeReducer.EmployeesReducer
  );
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  useEffect(() => {
    dispatch(
      GetATSModuleFeaturesAction({ module_name: "ATS Employees Onboarding" })
    );
  }, [dispatch]);
  useEffect(() => {
    const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
    if (inactive === true) {
      dispatch(GetEmployeesAction({ is_active: false,
            ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null 
       }));
    } else dispatch(GetEmployeesAction({ is_active: true,
          ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null 
     }));
    
  }, [dispatch, inactive, filters]);

  const handleAdd = () => {
    setCurrentData({})
    setOpenPopup(true)
  };
  const handleEdit = (event, row) => {
    setCurrentData(row)
    setOpenPopup(true);
  };
  const handleView = (event, row) => {
    history.push({
      pathname: "/Onboardemployee",
      state: { defaultValue: currentData, Mode: "editemployee" },
    });
  };

const handleImageUpload = async (e, rowData) => {
  e.stopPropagation();
  setSelectedEmployee(rowData);
  setOpenImageUpload(true);

  if (rowData.image) {
    setImageLoading(true);
    try {
      const bucketParams = {
        Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
        Key: rowData.image,
      };
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 15 * 60 }
      );
      setImagePreview(url);
    } catch (error) {
      console.warn("Failed to load existing image", error);
      setImagePreview(null); // Fallback to no image
    }
  } else {
    setImagePreview(null); // No image available
  }
};
useEffect(() => {
    const loadModels = async () => {
      try {
        await loadFaceApiModels();
      } catch (err) {
        console.error("Error loading face-api models:", err);
      }
    };

    loadModels();
  }, []);
const validatePhotoFile = async (file) => {
  const results = [];
  setImageValidation(true);
  try {
    if (!file) {
      toast.dismiss();
      toast.error("No file provided");
      return false;
    }

    // ensure face-api models loaded
    await loadFaceApiModels();

    // create image element
    const img = await new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      if (typeof file === "string" && file.startsWith("data:")) {
          image.src = file; 
        } else {
          image.src = URL.createObjectURL(file);
        }

      image.onload = () => {
          // revoke object URL if created to avoid memory leak
          if (typeof fileOrDataUrl !== "string") {
            try { URL.revokeObjectURL(image.src); } catch (e) {}
          }
          resolve(image);
        };
      image.onerror = (e) => reject(e);
      setTimeout(() => resolve(image), 3000);
    });

    if (!img || !img?.width || !img?.height) {
      toast.dismiss();
      toast.error("Invalid image dimensions");
      return false;
    }

    // face detection using TinyFaceDetector
    const detections = await faceapi
      .detectAllFaces(img, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks();
    if (!detections || detections?.length !== 1 || !detections[0]?.detection?.box) {
       toast.dismiss();
       toast.error("No face detected / Multiple faces present", { autoClose: 5000 });
       return false;
    }

    // exactly one face -> perform checks
    const detection = detections[0];
    const box = detection.detection.box;
    if (typeof box.x !== 'number' || typeof box.y !== 'number' || typeof box.width !== 'number' || typeof box.height !== 'number') {
      toast.dismiss();
      toast.error("Face detection quality is too low. Please upload a clearer photo.", { autoClose: 5000 });
      return false;
    }
    const faceRatio = box?.height / img?.height;
    const closeUpPass = faceRatio >= 0.35 && faceRatio <= 0.8;
    if (!closeUpPass) results.push("Face too far/close");

    // tilt check
    let tiltPass = false;
    const landmarks = detection?.landmarks;
    if (landmarks) {
      const leftEye = landmarks.getLeftEye?.();
      const rightEye = landmarks.getRightEye?.();
      if (leftEye && rightEye && leftEye[0] && rightEye[0]) {
        const eyeTilt = Math.abs(leftEye[0].y - rightEye[0].y);
        tiltPass = eyeTilt <= 10;
      }
    }
    if (!tiltPass) results.push("Tilted face");

    // lighting check
    try {
      const canvas = document.createElement("canvas");
      canvas.width = img?.width;
      canvas.height = img?.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let sum = 0;
      for (let i = 0; i < pixels.length; i += 4) {
        sum += (pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3;
      }
      const avgBrightness = sum / (pixels.length / 4);
      const lightingPass = avgBrightness >= 60 && avgBrightness <= 200;
      if (!lightingPass) results.push("Bad lighting");
    } catch (e) {
      results.push("Lighting check failed");
    }

    // final validation
    if (results.length > 0) {
      toast.dismiss();
      toast.error(
        results?.join(", ")
      );
      return false;
    }

    toast.dismiss();
    toast.success("Photo validation passed!");
    return true;
  } catch (err) {
    toast.error("Validation error: " + err.message);
    return false;
  } finally {
    setImageValidation(false);
  }
};
  const handleFileChange = async(event) => {
    const files = event.target.files;
    if (files && files[0]) {
      const file = files[0];
      // Validation
      if (file.size > 2000000) {
        toast.error("Maximum file size is 2 MB");
        return;
      }
      
      if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
        toast.error("Only .jpeg, .jpg, and .png formats are allowed");
        return;
      } 

      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
        setOpenCropModal(true);
      };
      reader.readAsDataURL(file);
    }
    // Reset input
    event.target.value = '';
  };

  const handleRotationChange = (event, newValue) => {
    setRotation(newValue);
    if (cropperRef.current?.cropper) {
      cropperRef.current.cropper.rotateTo(newValue);
    }
  };

const handleCrop = async() => {
  const cropper = cropperRef.current?.cropper;
  if (cropper) {
    const croppedCanvas = cropper.getCroppedCanvas({
      width: 300,
      height: 300,
      imageSmoothingQuality: "high",
    });
    if (croppedCanvas) {//null check
      const croppedDataUrl = croppedCanvas.toDataURL('image/jpeg', 0.8);
       const valid = await validatePhotoFile(croppedDataUrl);
        if (!valid) {
          return;
        }
      setCroppedImage(croppedDataUrl);
      setImagePreview(croppedDataUrl);
      setWebImage(null); // Clear webcam image when cropping
      setOpenCropModal(false);
      setUseWebcam(false);
    } else {
      toast.error("Failed to crop image");  // Add error handling
    }
  }
};

  const openWebcamModal = () => {
    setUseWebcam(true);
    setOpenCropModal(true);
  };

const captureImageFromWebcam = () => {
  try {
    const video = webcamRef.current?.video;
    if (!video) {
      throw new Error("Webcam not ready");
    }
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        
    const capturedImage = canvas.toDataURL('image/jpeg');
    if (capturedImage && capturedImage !== 'data:,') {
      setSelectedImage(capturedImage);
      setWebImage(capturedImage);
      setUseWebcam(false);
    } else {
      throw new Error("Failed to capture image");
    }
  } catch (error) {
    toast.error(error.message || "Failed to capture image");
    setUseWebcam(false);
    setOpenCropModal(false);
  }
};

const handleImageSave = async () => {
  try {
    
    let img_filename = "";
    let img_b64string = "";
    let old_image = "";
    let descriptor = "";
    setUploading(true);

    // Only process new image if cropped or webcam image exists
    const imageToProcess = croppedImage || webImage;
    if (imageToProcess) {
      // Convert image to blob and file
      const response = await fetch(imageToProcess);
      const blob = await response.blob();
      
      const mimeType = imageToProcess.split(';')[0].split(':')[1];
      const fileExtension = mimeType.split('/')[1];
      
      const file = new File([blob], `cropped-image.${fileExtension}`, {
        type: mimeType
      });

      // Convert to base64
      img_b64string = await convertBase64(file);
      
      // Generate filename
      img_filename = `${userData?.domain}/CoreHr/Employee/Profile/${uuidv4()}.${fileExtension}`;

      // Face detection
        const resData = await generateEmbeddingsControllerHelper({
          img_b64string: [img_b64string]
        })
        if(resData?.data?.statuscode === 200 && resData?.data?.data?.[0]?.embedding) {
          descriptor = resData?.data?.data?.[0]?.embedding;
        } else {
          toast.error("Face not detected. Please upload/take photo again.");
          return;
        }

      // Set old_image for replacement
      if (selectedEmployee?.image) {
        old_image = selectedEmployee.image;
      }
    } else {
      // No new image selected, keep existing
      img_filename = selectedEmployee?.image || "";
      descriptor = selectedEmployee?.descriptor || "";
    }

    const updateData = {
      domain_name: selectedEmployee?.domain_name,
      employee_id: selectedEmployee?.employee_id,
      image: img_filename,
      image_name: img_b64string,
      old_image: old_image,
      descriptor: descriptor,
    };

    const response = await UpdateEmployeeProfilePicHelper(updateData);

    if (response?.data?.statuscode === 200) {
      dispatch(GetEmployeesAction({ is_active: !inactive }));
      dispatch(GetHomeAction());
      handleImageModalClose();
      setSelectedEmployee(prev => ({ ...prev, image: img_filename }));
    } else {
      toast.error("Failed to update profile image");
    }
  } catch (error) {
    toast.error("An error occurred while updating the image");
  } finally {
    setUploading(false);
  }
};

const handleImageModalClose = () => {
  setOpenImageUpload(false);
  setCroppedImage(null);
  setWebImage(null);
  setSelectedImage(null);
  setImagePreview('');
  setUseWebcam(false);
  setOpenCropModal(false);
  setRotation(0);
  setImageLoading(false);
};

const handleImageDelete = async () => {
  setDeleting(true);
  try {
    const updateData = {
      domain_name: selectedEmployee?.domain_name,
      employee_id: selectedEmployee?.employee_id,
      image: "", 
      image_name: "",
      old_image: selectedEmployee?.image || "", 
      descriptor: "",
    };

    const response = await UpdateEmployeeProfilePicHelper(updateData);

    if (response?.data?.statuscode === 200) {
      dispatch(GetEmployeesAction({ is_active: !inactive }));
      dispatch(GetHomeAction());
      setImagePreview('');
      setCroppedImage(null);
      setWebImage(null); 
      setImageLoading(false);
      setSelectedEmployee(prev => ({ ...prev, image: null, descriptor: "" }));
    } else {
      toast.error("Failed to remove profile image");
    }
  } catch (error) {
    toast.error("Failed to remove profile image");
  } finally {
    setDeleting(false);
  }
};
  const handleExitPopup = (data) => {
    setOpenExitForm(true);
    setExitEmployeeData(data);
  };
  
  const handlePayrollSetupPopup = (data) => {
    setOpenTemplate(true);
    setCurrentData(data);
  };
  const handleClick = (event, data) => {
    setCurrentData(data);
    setAnchorEl(event.currentTarget);
  };
  const handleConfirmArchive = () => {
    setOpenDialog(true);
    setAnchorEl(null);
  };
  const handleToggle = (e) => {
    setInactive(!inactive);
};
  const handleUnArchive = () => {
    UpdateEmployeeStatusHelper({
      employee_id: currentData?.employee_id,
      is_active: true,
      successMessage: "Employee made Active Successfully",
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        dispatch(GetEmployeesAction({ is_active: false }));
      }
    });
    setOpenDialog(false);
  };

  const handleArchive = () => {
    UpdateEmployeeStatusHelper({
      employee_id: currentData?.employee_id,
      is_active: false,
      successMessage: "Employee made Inactive Successfully",
    }).then((res) => {
      if (res?.data?.statuscode === 200) {
        dispatch(GetEmployeesAction({ is_active: true }));
      }
    });
    setOpenDialog(false);
  };

  const getSelectedEmployeeIds = async() => {
    try{
      const selectedEmployeeIds = `{${selectedRows?.map((item) => item.employee_id).join(",")}}`;
      const res = await getExportEmployeeDataHelper({ employees_id: selectedEmployeeIds !== '{}' ? selectedEmployeeIds : null });
      if (res?.data?.statuscode === 200) {
          return res?.data?.data; 
      }
    } finally {
      setIsExporting(false);
    }
  }
  
  const handleExportSelected = async() => {
    setIsExporting(true);
    const selectedEmp =  await getSelectedEmployeeIds();
        const headers = [
          { label: "#", key: "serial_number" }, 
          { label: "Prev.Emp ID", key: "prev_employee_id" }, 
          { label: "Emp No", key: "emp_no" }, 
          { label: "First Name", key: "first_name" }, 
          { label: "Last Name", key: "last_name" },
          { label: "Gender", key: "gender" },
          { label: "Father's Name", key: "fathers_name" }, 
          { label: "Designation", key: "designation" },
          { label: "Department", key: "department" }, 
          { label: "Reporting Manager", key: "reporting_manager" },
          { label: "Work Location", key: "work_location" },
          { label: "Date of Joining", key: "doj" },
          { label: "Years of Experience", key: "years_of_experience" }, 
          { label: "Date of Birth", key: "dob" }, 
          { label: "Age", key: "age" },
          { label: "Date of Marraige", key: "marriage_date" },
          { label: "Current Address", key: "current_address" }, 
          { label: "Permanent Address", key: "permanent_address" }, 
          { label: "Mobile Number", key: "mobile_no" },
          { label: "PAN No", key: "pan" }, 
          {label: "Aadhar No", key: "aadhar" },
          { label: "Qualification", key: "qualif_1" },  
          { label: "Emergency Contact", key: "emergency_contact_person" }, 
          { label: "Emergency Number", key: "emergency_contact_no" },
          { label: "Blood Group", key: "blood_group" },
          { label: "Email", key: "email" } 
      ];
      
    const csvData = [headers.map(header => header.label)];
    selectedEmp?.forEach((row, index) => {
    const rowData = headers.map(header => {
        let value = row?.employee_master_report?.[0]?.[header.key] ?? "";
        if (typeof value === "string" && value.includes(",")) {
            value = `"${value}"`; 
        }
        if (header.key === "serial_number") return index + 1; 
        if (header.key === "aadhar") {
          value = `="${value}"`;
      }
        return value;
    });
      csvData.push(rowData);
    });
    const csv = csvData.map(row => row.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = "Employees Master Report.csv";
    downloadLink.setAttribute("target", "_blank");
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
    setIsExporting(false);
  };

  const fetchGetEmployee = () => {
    dispatch(GetEmployeesAction({ is_active: !inactive }));
  } 
    const canvasRef = useRef(null);
    const [faceAligned, setFaceAligned] = useState(false);
  
    useEffect(() => {
      let interval;
      if (useWebcam) {
        interval = setInterval(detectFaceAlignment, 300); // check every 300ms
      } else {
        setLightingError("");
        setFaceAligned(false);
      }
      return () => clearInterval(interval);
    }, [useWebcam]);
  
    const detectFaceAlignment = async () => {
      const video = webcamRef.current?.video;
      const canvas = canvasRef.current;
      if (!video || !canvas || video.readyState !== 4 || !video.videoWidth || !video.videoHeight) return;
  
      const displaySize = { width: video.videoWidth, height: video.videoHeight };
      faceapi.matchDimensions(canvas, displaySize);
  
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
  
      // --- Frame setup (smaller square) ---
      const frameWidth = displaySize.width * 0.5;
      const frameHeight = displaySize.height * 0.4;
      const frameX = (displaySize.width - frameWidth) / 2;
      const frameY = (displaySize.height - frameHeight) / 2;
  
      const cornerLength = 30;
      const lineWidth = 8;
      ctx.lineWidth = lineWidth;
  
      let faceAlignedNow = false;
      let errorMessage = "";
  
      // 1. Lighting Check
      const brightness = checkLighting(video);
      if (brightness < 60) {
        errorMessage = "Lighting is too low, please move to a brighter area.";
      } else {
        // 2. Face Presence & Landmarks Detection
        const detection = await faceapi
          .detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())
          .withFaceLandmarks();
  
        if (!detection) {
          errorMessage = "No face detected. Please align your face inside the frame.";
        } else {
          const { box } = detection.detection;
          const landmarks = detection.landmarks;
  
          // 3. Close-up Validation (ratio check)
          const faceRatio = box.height / displaySize.height;
          const closeUpPass = faceRatio >= 0.28 && faceRatio <= 0.85;
  
          if (!closeUpPass) {
            errorMessage = faceRatio < 0.28 ? "Move closer to the camera." : "Move slightly back from the camera.";
          } else {
            // 4. Centering Validation (overlap with guide frame check)
            const faceArea = box.width * box.height;
            const intersectionX = Math.max(box.x, frameX);
            const intersectionY = Math.max(box.y, frameY);
            const intersectionWidth =
              Math.min(box.x + box.width, frameX + frameWidth) - intersectionX;
            const intersectionHeight =
              Math.min(box.y + box.height, frameY + frameHeight) - intersectionY;
  
            let centeringPass = false;
            if (intersectionWidth > 0 && intersectionHeight > 0) {
              const intersectionArea = intersectionWidth * intersectionHeight;
              const intersectionRatio = intersectionArea / faceArea;
              if (intersectionRatio >= 0.75) {
                centeringPass = true;
              }
            }
  
            if (!centeringPass) {
              errorMessage = "Center your face in the camera frame.";
            } else {
              // 5. Eye Alignment (tilt angle) Validation
              const leftEye = landmarks.getLeftEye();
              const rightEye = landmarks.getRightEye();
  
              const leftEyeCenter = {
                x: leftEye.reduce((s, p) => s + p.x, 0) / leftEye.length,
                y: leftEye.reduce((s, p) => s + p.y, 0) / leftEye.length,
              };
              const rightEyeCenter = {
                x: rightEye.reduce((s, p) => s + p.x, 0) / rightEye.length,
                y: rightEye.reduce((s, p) => s + p.y, 0) / rightEye.length,
              };
  
              const angle =
                Math.atan2(
                  rightEyeCenter.y - leftEyeCenter.y,
                  rightEyeCenter.x - leftEyeCenter.x
                ) * (180 / Math.PI);
  
              if (Math.abs(angle) > 10) {
                errorMessage = "Look straight at the camera.";
              } else {
                // 6. Yaw Rotation (looking left/right) Validation
                const nose = landmarks.getNose();
                const noseCenter = {
                  x: nose.reduce((s, p) => s + p.x, 0) / nose.length,
                  y: nose.reduce((s, p) => s + p.y, 0) / nose.length,
                };
  
                const leftDist = Math.abs(noseCenter.x - leftEyeCenter.x);
                const rightDist = Math.abs(rightEyeCenter.x - noseCenter.x);
  
                if (leftDist === 0 || rightDist === 0) {
                  errorMessage = "Please look straight at the camera.";
                } else {
                  const yawRatio = leftDist / rightDist;
                  if (yawRatio < 0.6 || yawRatio > 1.6) {
                    errorMessage = "Please look straight at the camera.";
                  } else {
                    faceAlignedNow = true;
                  }
                }
              }
            }
          }
        }
      }
  
      setLightingError(errorMessage);
      setFaceAligned(faceAlignedNow);
  
      // --- Draw corners ---
      ctx.strokeStyle = faceAlignedNow ? "green" : "red";
  
      // Top-left corner
      ctx.beginPath();
      ctx.moveTo(frameX, frameY + cornerLength);
      ctx.lineTo(frameX, frameY);
      ctx.lineTo(frameX + cornerLength, frameY);
      ctx.stroke();
  
      // Top-right corner
      ctx.beginPath();
      ctx.moveTo(frameX + frameWidth - cornerLength, frameY);
      ctx.lineTo(frameX + frameWidth, frameY);
      ctx.lineTo(frameX + frameWidth, frameY + cornerLength);
      ctx.stroke();
  
      // Bottom-left corner
      ctx.beginPath();
      ctx.moveTo(frameX, frameY + frameHeight - cornerLength);
      ctx.lineTo(frameX, frameY + frameHeight);
      ctx.lineTo(frameX + cornerLength, frameY + frameHeight);
      ctx.stroke();
  
      // Bottom-right corner
      ctx.beginPath();
      ctx.moveTo(frameX + frameWidth - cornerLength, frameY + frameHeight);
      ctx.lineTo(frameX + frameWidth, frameY + frameHeight);
      ctx.lineTo(frameX + frameWidth, frameY + frameHeight - cornerLength);
      ctx.stroke();
    };
    
    const [worklocationData, setWorklocationData] = useState({
          load: true,
          values: [],
    });
    const handleWorkLoacation = () => {
      GetUserWorkLocationHelper().then(res => {
        if(res?.data?.statuscode === 200){
          setWorklocationData({ load: false, values: res?.data?.data || [] })
        } else {
          setWorklocationData({ load: false, values: [] })
        }
      })
    }
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
      }
    }
    useEffect(() => {
      handleWorkLoacation();
    }, []);
    const showWorkLocation = !worklocationData.load && worklocationData.values.length > 1;
  
    // Employee live location tracking logic
    const liveRef = useRef({});
    const hasUpdatesRef = useRef(false);
    const [liveEmployees, setLiveEmployees] = useState({});
    const [status, setStatus] = useState("Disconnected");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [mapOpen, setMapOpen] = useState(false);
  
    // ---------------- SOCKET Connection and receive live data ----------------
    useEffect(() => {
      socket.connect();
      socket.on("connect", () => {
        setStatus("Connected");
  
        socket.emit("join_admin", {
          domain_name: getDomain(),
          user_id: getUserId(),
        });
      });
  
      socket.on("employee_location_update", (data) => {
        liveRef.current[data.employeeId] = {
          time: data.timestamp
            ? new Date(data.timestamp).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })
            : "",
          ...data,
        };
        hasUpdatesRef.current = true;
      });
      socket.on("disconnect", () => {
        setStatus("Disconnected");
      });
  
      return () => {
        socket.off("employee_location_update");
        socket.disconnect();
      };
    }, []);
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
      const shouldRun = Object.keys(liveEmployees).length > 0; 
      if(!shouldRun) return;  // For trigger re-rendering, since if the employee live location not updated more than 30sec then for changing the icon, re-render required. 
      const interval = setInterval(() => {
        setNow(Date.now());
      }, 5000);

      return () => clearInterval(interval);
    }, [liveEmployees]);

    useEffect(() => {
      const interval = setInterval(() => {
        if (!hasUpdatesRef.current) return; // when new updated live location trigger then only update the live employee
        setLiveEmployees({ ...liveRef.current });
        hasUpdatesRef.current = false;

      }, 10000);

      return () => clearInterval(interval);
       // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOpenMap = (employee) => {
      setSelectedEmployeeId(employee?.employeeId)
      setMapOpen(true);
    }
    const employeeLiveMapData = selectedEmployeeId && liveEmployees[selectedEmployeeId] ? liveEmployees[selectedEmployeeId] : null;
    
  return (
    <Box  sx={{ maxHeight: "calc(100vh - 75px)", overflowY: "auto" }}>
      <Popup
        title={currentData?.employee_id ? "Edit Employee" : "Add Employee"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        fullWidth={true}
        maxWidth="sm"
      >
        <AddEmployeePopup
          editRecord={currentData}
          setOpenPopup={setOpenPopup}
          inactive={inactive}
        />
      </Popup>
      <Popup
        maxWidth="sm"
        fullWidth={true}
        title={`Payroll Configuration - ${currentData?.name}`}
        openPopup={openTemplate}
        setOpenPopup={setOpenTemplate}
      >
        <EmployeePayroleTemplate tab={!inactive} emp={true} createEmp={false} setOpenTemplate={setOpenTemplate} openTemplate={openTemplate} currentData={currentData} />
      </Popup>
      <Popup  
        title={`Profile Picture - ${selectedEmployee?.name}`}  
        openPopup={openImageUpload}  
        setOpenPopup={handleImageModalClose}  
        fullWidth={false}  
        maxWidth="xs"
      >  
        <Box sx={{ p: 1.5, textAlign: 'center' }}>
          <Badge      
            overlap="circular"      
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}      
            badgeContent={        
              <IconButton          
                size="small"          
                onClick={() => fileInputRef.current?.click()}          
                sx={{            
                  width: 20,            
                  height: 20,            
                  backgroundColor: 'primary.main',            
                  color: 'white',            
                  '&:hover': {              
                    backgroundColor: 'primary.dark',            
                  },          
                }}        
              >          
                <PhotoCamera sx={{ fontSize: 12 }} />        
              </IconButton>      
            }    
          >  
           <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <Avatar        
              src={croppedImage || webImage || imagePreview}        
              alt={selectedEmployee?.name}        
              sx={{          
                width: 100,          
                height: 100,          
                margin: '0 auto 15px',          
                border: '2px solid #f0f0f0',          
                fontSize: 32        
              }}      
            >        
              {imageLoading ? (          
                <CircularProgress size={30} />        
              ) : (          
                !croppedImage && !webImage && !imagePreview && <Person />        
              )}      
            </Avatar>  
            {imageValidation && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '90%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 10,
                    borderRadius: '50%',
                  }}
                >
                  <CircularProgress color="action" disableShrink/>
                </div>
              )}  
            </Box>    
          </Badge>        
          
          <Typography variant="subtitle1" gutterBottom sx={{ fontSize: '0.9rem', mb: 1 }}>      
            {selectedEmployee?.name}    
          </Typography>        
          
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 2 }}>      
            <Tooltip title="Upload">        
              <IconButton          
                onClick={() => fileInputRef.current?.click()}          
                size="small"
                disabled={imageValidation}
                sx={{            
                  width: 36,            
                  height: 36,            
                  border: '1px solid',            
                  borderColor: 'primary.main',            
                  color: 'primary.main',            
                  '&:hover': {              
                    backgroundColor: 'primary.main',              
                    color: 'white'            
                  }          
                }}        
              >          
                <InsertPhotoIcon fontSize="small" />        
              </IconButton>      
            </Tooltip>            
            
            <Tooltip title="Camera">        
              <IconButton          
                onClick={openWebcamModal}          
                size="small"
                disabled={imageValidation}
                sx={{            
                  width: 36,            
                  height: 36,            
                  border: '1px solid',            
                  borderColor: 'primary.main',            
                  color: 'primary.main',            
                  '&:hover': {              
                    backgroundColor: 'primary.main',              
                    color: 'white'            
                  }          
                }}        
              >          
                <CameraAltIcon fontSize="small" />        
              </IconButton>      
            </Tooltip>            
            
            {(croppedImage || webImage || selectedEmployee?.image) && (        
              <Tooltip title="Remove">          
                <IconButton            
                  onClick={handleImageDelete}            
                  disabled={deleting || imageValidation}            
                  size="small"
                  sx={{              
                    width: 36,              
                    height: 36,              
                    border: '1px solid',              
                    borderColor: 'error.main',              
                    color: 'error.main',              
                    '&:hover': {                
                      backgroundColor: 'error.main',                
                      color: 'white'              
                    },              
                    '&:disabled': {                
                      borderColor: 'grey.300',                
                      color: 'grey.300'              
                    }            
                  }}          
                >            
                  {deleting ? <CircularProgress size={16} /> : <DeleteIcon fontSize="small" />}          
                </IconButton>        
              </Tooltip>      
            )}            
            
            <Tooltip title="Save">        
              <IconButton          
                onClick={handleImageSave}          
                disabled={uploading || imageValidation}          
                size="small"
                sx={{            
                  width: 36,            
                  height: 36,            
                  border: '1px solid',            
                  borderColor: 'success.main',            
                  color: 'success.main',            
                  backgroundColor: uploading ? 'grey.100' : 'transparent',            
                  '&:hover': {              
                    backgroundColor: 'success.main',              
                    color: 'white'            
                  },            
                  '&:disabled': {              
                    borderColor: 'grey.300',              
                    color: 'grey.300'            
                  }          
                }}        
              >          
                {uploading ? <CircularProgress size={16} /> : <TaskAltIcon fontSize="small" />}        
              </IconButton>      
            </Tooltip>            
            
            <Tooltip title="Cancel">        
              <IconButton          
                onClick={handleImageModalClose}          
                size="small"
                sx={{            
                  width: 36,            
                  height: 36,            
                  border: '1px solid',            
                  borderColor: 'grey.400',            
                  color: 'grey.600',            
                  '&:hover': {              
                    backgroundColor: 'grey.400',              
                    color: 'white'            
                  }          
                }}        
              >          
                <Close fontSize="small" />        
              </IconButton>      
            </Tooltip>    
          </Box>        
          
          <input      
            type="file"      
            ref={fileInputRef}      
            style={{ display: "none" }}      
            accept="image/jpeg,image/jpg,image/png"      
            onChange={handleFileChange}    
          />  
        </Box>
      </Popup>

      {/* Compact Cropping/Webcam Modal */}
      <Modal open={openCropModal} onClose={() => {
        setOpenCropModal(false);
        setUseWebcam(false);
      }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 1,
            px: 4,
            py: 2,
            boxShadow: 24,
            maxWidth: 350,
            width: "100%",
            textAlign: "center",
          }}
        >
          <IconButton
            size="small"
            sx={{ position: "absolute", top: 8, right: 10 }}
            onClick={() => {
              setOpenCropModal(false);
              setUseWebcam(false);
            }}
          >
            <Close />
          </IconButton>
                      
          <Typography variant="subtitle1" sx={{ mb: 2, fontSize: '0.9rem' }}>
            {useWebcam ? "Take Photo" : "Crop Image"}
          </Typography>
                      
          {useWebcam ? (
            <Box 
              sx={{
                  position: "relative",
                  width: "100%",
                  maxWidth: 350,
                  margin: "auto",
                }}>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width="100%"
                videoConstraints={{
                    facingMode: facingMode,
                  }}
                style={{
                  width: "100%",
                  height: 300,
                  objectFit: "cover",
                }}
              />
              {isMobileOrTablet && (
                <IconButton
                  onClick={() => setFacingMode((prev) => (prev === "user" ? "environment" : "user"))}
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "rgba(0,0,0,0.7)",
                    },
                    zIndex: 10,
                  }}
                >
                  <FlipCameraAndroidIcon />
                </IconButton>
              )}
              <canvas
                  ref={canvasRef}
                  style={{
                    position: "absolute",
                    top: -60,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                />
                <Tooltip
                  title={
                    faceAligned
                      ? ""
                      : (lightingError || "Align your face properly within the frame")
                  }
                  arrow
                  placement="bottom"
                >
                  <span>
                  <Button
                    onClick={captureImageFromWebcam}
                    variant="contained"
                    size="small"
                    startIcon={<CameraAlt />}
                    sx={{ mt: 1 }}
                    disabled={!faceAligned}
                  >
                    Capture
                  </Button>
                  </span>
                </Tooltip>
            </Box>
          ) : (
            selectedImage && (
              <Box sx={{ marginTop: 1 }}>
                <Cropper
                  ref={cropperRef}
                  src={selectedImage}
                  style={{ height: 250, width: "100%" }}
                  initialAspectRatio={1}
                  aspectRatio={1}
                  guides={false}
                  movable={true}
                  zoomable={true}
                  scalable={true}
                  cropBoxResizable={false}
                  cropBoxMovable={true}
                  minCropBoxWidth={165}
                  minCropBoxHeight={165}
                  background={true}
                />
                                  
                <Box sx={{ marginTop: 1, px: 1 }}>
                  <Typography variant="caption">Rotate</Typography>
                  <Slider
                    value={rotation}
                    min={-180}
                    max={180}
                    step={1}
                    onChange={handleRotationChange}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) => `${value}°`}
                    size="small"
                  />
                </Box>
                                  
                <Button
                  onClick={handleCrop}
                  variant="contained"
                  size="small"
                  sx={{ mt: 1 }}
                  disabled={imageValidation}
                  startIcon={imageValidation ? <CircularProgress size={18} color="inherit" disableShrink /> : null}
                >
                  Crop
                </Button>
              </Box>
            )
          )}
        </Box>
      </Modal>
      <Box>
        <MaterialTable
          isLoading={isEmployeeLoading}
          onRowClick={(event, rowData) => {
            if (ExternalUserCoreHr) return;
            handleEdit(event, rowData);
          }}
          columns={[
            {
              title: (<span>
                         Status&nbsp;
                          <Tooltip title="Shows the user’s current status based on the most recent mobile app connectivity." placement="bottom" arrow>
                                <InfoOutlinedIcon color="action" style={{ verticalAlign: "middle", cursor: "pointer", marginBottom: "4px", fontSize: "16px" }} />
                          </Tooltip>
                      </span>),
              cellStyle: { padding: "10px 4px 10px 10px" },
              headerStyle: { padding: "10px 4px 10px 3px" },
              sorting: false,
              field: "employee_id",
              grouping: false,
              render: (rowData) => {
                const emp = liveEmployees[rowData?.employee_id];
                let isLive = false;
                if (emp?.timestamp) {
                  const diff = now - emp?.timestamp; // in ms
                  isLive = diff <= 35000; // 35 seconds
                }
                return (
                  isLive ? (
                    <Tooltip title="Online: Track on Map">
                      <IconButton
                        onClick={(e) =>{
                          e.stopPropagation();
                          handleOpenMap(emp)}}
                        color="primary"
                        sx={{ ml: -1 }}
                      >
                        <PersonPinCircleIcon
                          sx={{
                            color: "rgb(86, 202, 0)",
                            cursor: "pointer"
                          }}
                          size="small"
                        />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Offline">
                      <LocationOffIcon
                        sx={{
                          color: "rgb(255, 76, 81)",
                          cursor: "default"
                        }}
                        size="small"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Tooltip>
                  )
                );
              }
            },
            {
              title: "Emp No",
              cellStyle: { padding: "10px 10px 10px 13px" },
              field: "employee_no",
              grouping: false,
            },
            {
              title: "Name",
              cellStyle: { padding: "10px 10px 10px 13px" },
              field: "name",
              grouping: false,
              render: (rowData) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                      <IconButton
                        size="small"
                        onClick={(e) => handleImageUpload(e, rowData)}
                        sx={{
                          width: 18,
                          height: 18,
                          backgroundColor: 'primary.main',
                          color: 'white',
                          '&:hover': {
                            backgroundColor: 'primary.dark',
                          },
                        }}
                      >
                        <PhotoCamera sx={{ fontSize: 10 }} />
                      </IconButton>
                    }
                  >
                    <LazyEmployeeAvatar 
                      employee={rowData} 
                      onImageClick={handleImageUpload} 
                    />
                  </Badge>
                  <span>{rowData.name}</span>
                </Box>
              ),
            },
            {
              title: "Email",
              cellStyle: { padding: "10px 10px 10px 13px" },
              field: "office_email",
              grouping: false,
            },
            {
              title: "Work Location",
              cellStyle: { padding: "10px 10px 10px 13px"},
              field: "work_location",
              hidden: !showWorkLocation,
              render: (rowData) => {
                return rowData?.work_location || "N/A";
              },
            },
            {
              title: "DOJ",
              headerStyle: {padding: "10px 28px 10px 0px", textAlign: "start" }, 
              cellStyle: { padding: "10px 0px 10px 3px", textAlign: "start" },
              field: "createdon",
              render: (rowData) => {
                return ConvertDateTime(rowData.doj);
              },
            },
            {
              title: "Onboarding", field: "empform_onboarding_status",sorting:false, 
              headerStyle: { textAlign: "left", padding: "10px 10px 10px 13px" }, 
              cellStyle: { padding: "10px", textAlign: "center" },
              render: rowData => {
                return rowData.empform_onboarding_status ? <TaskAltIcon onClick={(e) => {e.stopPropagation()}} sx={{ color: "rgb(86, 202, 0)", cursor: 'default' }} />
                  : <HighlightOffIcon onClick={(e) => {e.stopPropagation()}} sx={{ color: "rgb(255, 76, 81)", cursor: 'default' }} />
              }
            },

            {
              title: "Payroll Setup", field: "payroll_setup_flag",sorting: false, 
              hidden: !checkPayrollAccess() || !(userData?.f_country_code === "IND"),
              // !['cvtmeepl', "xpohrmeepl", "altiio", "adobemeepl", "kmkmeepl", "paycmeepl", "bpmeepl", "nirahameepl", "abmeepl", "uatkmmeepl","sogbimeepl"].includes(userData?.domain) || !(userData?.f_country_code === "IND"), 
              headerStyle: { textAlign: "left", padding: "10px 10px 10px 13px" }, 
              cellStyle: { padding: "10px", textAlign: "center" },
              render: rowData => {
                return rowData.payroll_setup_flag ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePayrollSetupPopup(rowData);
                  }}
                />
                  : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)", cursor: "pointer" }} onClick={(e) => {
                    e.stopPropagation();
                    handlePayrollSetupPopup(rowData);
                  }} />
              }
            },
            {
              title: "Exit", field: "exit_status",sorting:false, 
              headerStyle: { textAlign: "left" }, 
              cellStyle: { padding: "10px", textAlign: "center" },
              hidden: inactive,
              render: rowData => {
                return rowData?.core_hr_user_type === "Owner" ? 
                <Tooltip title="Not allowed">
                  <NotInterestedIcon color="disabled" sx={{cursor: "default"}}/>
                  </Tooltip> : rowData.exit_status === "Not Started" ? 
                  <Tooltip title={ExternalUserCoreHr ? "Action is disabled." : ""}>
                    <LogoutIcon 
                      color={!ExternalUserCoreHr ? "primary" : "disabled"}
                      disabled={ExternalUserCoreHr}
                      onClick={(e) => {
                      e.stopPropagation();
                      handleExitPopup(rowData);
                    }}/>
                  </Tooltip>
                  : <Tooltip arrow title={<>
                    Status: {rowData?.exit_status}, Type: {rowData?.exit_type}
                  </> }>
                    <PhonelinkEraseIcon onClick={(e) => {e.stopPropagation();}} sx={{ color: "rgb(255, 76, 81)", cursor: 'default' }} />
                  </Tooltip>
              }
            },
            {
              title: "Actions",
              field: "action",
              width:"8%",
              grouping: false,
              hidden: inactive, 
              sorting: false,
              headerStyle: {  textAlign: "center" }, 
              cellStyle: { padding: "10px", textAlign: "center", marginTop:"-14px" },
              render: (rowData) => (
                <Tooltip title="Actions">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClick(e, rowData);
                    }}
                    sx={{
                      padding: "0px",width: "30px", height: "30px"
                    }}
                  >
                    <MoreVertIcon fontSize="small" sx={{ fontWeight: "bold" }} />
                  </IconButton>
                </Tooltip>
              ),
            }
            
          ]}
          data={employees_options}
          options={{
            maxBodyHeight: "calc(100vh - 195px)",
            minBodyHeight: "calc(100vh - 195px)",
            rowStyle: { fontSize: "13px", cursor: ExternalUserCoreHr ? "default" : "pointer"},
            headerStyle: { padding: "10px", fontWeight: "bold" },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "left",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            exportFileName: "Employees",
            addRowPosition: "first",
            selection: true,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: false,
          }}
          
          onSelectionChange={(rows) => setSelectedRows(rows)}
          components={{
            Toolbar: (props) => (
              <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
              <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "#f3edfd",
                    padding: "0px 20px",
                    flexGrow: 1
                    
                  }}
                >
                  {isSmallScreen && <Box
                   sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    rowGap: 1.5,
                    columnGap: 2
                  }}
                >
                  {showWorkLocation && (
                    <Box sx={{width: "210px", display: "flex", alignItems: "center", pr: 2.5}}>
                        <SelectableMultiSelect
                            multiple
                            label="Work Location"
                            placeholder="Select Location"
                            value={filters?.ats_work_location_id}
                            loading={handleWorkLoacation}
                            fieldLabel="work_location_name"
                            name="ats_work_location_id"
                            size="small"
                            onChangeEvent={handleFilterChange}
                            data={worklocationData}
                            menuHeight={150} // optional
                        />
                    </Box>
                  )}
                  <Box>
                    <Tooltip title={status === "Connected" ? "Admin: Online" : "Admin: Offline"}>
                      <Box
                          sx={{
                          backgroundColor:
                              status === "Connected" ? "success.main" : "#fd7567",
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          }}
                      />
                    </Tooltip>
                  </Box>
                  <Box>
                    <Tooltip
                      title={inactive ? "Toggle to view active users" : "Toggle to view archived users"}
                    >
                      <div>
                        <CustomToggle
                          isChecked={inactive}
                          setIsChecked={handleToggle}
                          handleToggleChange={handleToggle}
                          Yestext={"Inactive"}
                          NoText={"Active"}
                          style={{
                            height: '40px',
                            labelPadding: '2px 5px',
                          }}
                        />
                      </div>
                    </Tooltip>
                  </Box>
                  <Box>
                    <Tooltip title="Add Employee">
                    <IconButton onClick={handleAdd} color="primary">
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                  </Box>
                    {selectedRows.length !== 0 &&
                      <Box>
                        <Tooltip title="Export">
                          <IconButton onClick={handleExportSelected}>
                            <CloudDownloadIcon />
                          </IconButton>
                        </Tooltip>
                </Box>}
                </Box>
                  }
                </Box>
                 
                {!isSmallScreen && <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f3edfd",
                  }}
                >
                  {showWorkLocation && (
                    <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.3}}>
                        <SelectableMultiSelect
                            multiple
                            label="Location"
                            placeholder="Select Location"
                            value={filters?.ats_work_location_id}
                            loading={handleWorkLoacation}
                            fieldLabel="work_location_name"
                            name="ats_work_location_id"
                            size="small"
                            onChangeEvent={handleFilterChange}
                            data={worklocationData}
                            menuHeight={150} // optional
                        />
                    </Box>
                  )}
                  </Box>
                  }
                  <Box
                    sx={{
                        "& .MuiToolbar-root": {
                        padding: "14px 16px !important",
                        margin: "0 !important",
                        minHeight: "48px !important",
                        },
                        "& .MuiFormControl-root": {
                        margin: "0 !important",
                        },
                        "& .MuiInputBase-root": {
                        marginLeft: "-20px !important",
                        marginRight: "-25px !important"
                        }
                    }}
                    >
                        <MTableToolbar {...props} />
                  </Box>
                  {!isSmallScreen && <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f3edfd",
                    pr: 2,
                  }}
                >
                  <Box>
                    <Tooltip
                      title={inactive ? "Toggle to view active users" : "Toggle to view archived users"}
                    >
                      <div>

                        <CustomToggle
                          isChecked={inactive}
                          setIsChecked={handleToggle}
                          handleToggleChange={handleToggle}
                          Yestext={"Inactive"}
                          NoText={"Active"}
                          style={{
                            height: '40px',
                            labelPadding: '2px 5px',
                          }}
                        />
                      </div>
                    </Tooltip>
                  </Box>
                  <Box>
                    <Tooltip title={status === "Connected" ? "Admin: Online" : "Admin: Offline"}>
                      <Box
                          sx={{
                          backgroundColor:
                              status === "Connected" ? "success.main" : "#fd7567",
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          }}
                      />
                    </Tooltip>
                  </Box>
                  <Box>
                  <Tooltip title={ExternalUserCoreHr ? "Action is disabled." : "Add Employee"}>
                    <span>
                      <IconButton onClick={handleAdd} color="primary" disabled={ExternalUserCoreHr}>
                        <AddIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                  </Box>
                  
                  {selectedRows.length !== 0 &&
                    <Box>
                     <Tooltip title="Export">
                        <IconButton onClick={handleExportSelected} disabled={isExporting}>
                          {isExporting ? <CircularProgress size={24} /> : <CloudDownloadIcon />}
                        </IconButton>
                      </Tooltip>
                    </Box>}
                </Box>
                }
                </Box>
            ),
            Overlay: () => null,
            OverlayLoading: () => <BackdropMeepl open={true} />,
          }}  
          title=""
          />
        <Menu
          id="more-options-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "more-options-button",
          }}
        >
          <MenuItem onClick={(event, rowData) => {
            handleView(event, rowData);
          }}>
            <ListItemIcon>
              <VisibilityIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              View Employee Detail
            </ListItemText>
          </MenuItem>
          {(currentData?.employee_id === userData?.employee_id) || (currentData?.core_hr_user_type === "Owner") || ExternalUserCoreHr ? (
            <MenuItem disabled>
              <ListItemIcon>
                <ArchiveIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                {inactive ? "Make Active" : "Make Inactive"}
              </ListItemText>
            </MenuItem>
          ) : (
            <MenuItem onClick={handleConfirmArchive}>
              <ListItemIcon>
                <ArchiveIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                {inactive ? "Make Active" : "Make Inactive"}
              </ListItemText>
            </MenuItem>
          )}

        </Menu>
        <ConfirmationDialog
          title={inactive ? "Make Active" : "Make Inactive"}
          content={
            inactive
              ? "Are you sure want to make active ?"
              : "Making this user inactive will permanently archive the user and all associated data. This action cannot be undone. Do you want to proceed?"
          }
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="Users"
          OkButtonText={inactive ? "Make Active" : "Make Inactive"}
          onSubmit={inactive ? handleUnArchive : handleArchive}
        />
      </Box>
      <Popup
        maxWidth="sm"
        fullWidth={true}
        title={`Initiate Employee Exit - ${exitEmployeeData?.name}`}
        openPopup={openExitForm}
        setOpenPopup={setOpenExitForm}
      >
        <MyEcms currentMode={"admin"} exitEmployeeData={exitEmployeeData} setOpenExitForm={setOpenExitForm} fetchGetEmployee={fetchGetEmployee} />
      </Popup>

      {/* employee live tracking map popup */}
      <Popup
        maxWidth="md"
        fullWidth={true}
        title={`Live Tracking ${employeeLiveMapData?.name}`}
        openPopup={mapOpen}
        setOpenPopup={setMapOpen}
      >
        <EmployeeLocationMap employeeMapData={employeeLiveMapData} maxheight={"70vh"} />
      </Popup>
    </Box>
  );
};

export default MyEmployeeGrid;
